export default "__VITE_ASSET__8SQRZ25L__"